import {Component, EventEmitter, Input, Output} from '@angular/core';
@Component({
  selector: 'app-drop-zone',
  templateUrl: './drop-zone.component.html',
  styleUrls: ['./drop-zone.component.scss']
})
export class DropZoneComponent {

  @Output() newItemEvent = new EventEmitter();
  files: File[] = [];


  @Input('required-prescription') requiredPrescription!: string;
  @Input() prescription!: string;



  constructor(
  ) { }


  /**
   * IMAGE DRUG & DROP
   * onSelect()
   * onRemove()
  */
  onSelect(event: { addedFiles: any; }) {
    if (event) {
      this.files.push(...event.addedFiles);
      this.newItemEvent.emit(this.files);
    }
  }

  onRemove(event: File) {
    this.files.splice(this.files.indexOf(event), 1);
  }

}

